<template>
  <div class="admin-datatable">
    <v-card>
    <v-toolbar dark flat color="primary">
      <v-toolbar-title>Trenerzy</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="!showAdd" color="accent" @click="showAdd = true" dark>dodaj trenera</v-btn>
      <v-btn v-if="showAdd" flat small @click="showAdd = false">ukryj</v-btn>
    </v-toolbar>
    </v-card>
    <v-slide-y-transition>
    <v-card class="mt-2" v-if="showAdd">
      <trainer-add-form @success="showAdd = false; refresh()"></trainer-add-form>
    </v-card>
    </v-slide-y-transition>
    <v-card class="mt-2 pb-1">
      <v-card-title>
        <v-form class="flex">
          <v-layout row wrap justify-start>
            <v-flex xs12 sm6 md4 xl3 class="pa-1">
              <v-text-field v-model="context.searchQuery"
                clearable
                label="Szukaj"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4 xl3 class="pa-1">
              <v-select
                v-model="context.isActive"
                :items="[{text: 'Tak', value: true}, {text: 'Nie', value: false}]"
                label="Konto aktywne"
                clearable
              ></v-select>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="trainers"
        :pagination.sync="context"
        :rows-per-page-items="perPageOptions"
        :total-items="rowsTotal"
        :loading="loading"
      >
        <template slot="items" slot-scope="props">
          <tr>
          <td>
            <router-link :to="{ name: 'trainer-runners', params: { id: props.item.id }}">
              {{props.item.first_name}} {{props.item.last_name}}
            </router-link>
          </td>
          <td>{{ props.item.email}}</td>
          <td>{{ formatterBool(props.item.is_active)}}</td>
          <td class="actions">
            <rp-icon
              type="edit"
              tooltip="edytuj"
              class="mr-2"
              @click="props.expanded = !props.expanded"
            />
            <v-menu bottom left>
              <v-btn
                slot="activator"
                icon
              >
                <v-icon color="grey darken-2">more_vert</v-icon>
              </v-btn>

              <v-list>
                <v-list-tile :to="{ name: 'trainer-data', params: { id: props.item.id }}">
                  <v-list-tile-title>Szczegóły</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-if="props.item.is_active" @click.stop="deactivateTrainer(props.item)">
                  <v-list-tile-title>Deaktywuj konto</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-if="!props.item.is_active" @click.stop="activateTrainer(props.item)">
                  <v-list-tile-title>Aktywuj konto</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </td>
          </tr>
        </template>
        <template slot="expand" slot-scope="props">
            <trainer-update-form :trainer-data="props.item" @success="props.expanded = false; refresh()"></trainer-update-form>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import {fetchTrainers, deactivateTrainer, activateTrainer, sendMailTrainer} from './api'
import {ListMixin} from '@/utils/ListMixin'
import {boolFormatter} from '@/utils/formatters'
import iziToast from 'izitoast'
import _ from 'lodash'

import TrainerAddForm from './TrainerAddForm'
import TrainerUpdateForm from './TrainerUpdateForm'

export default {
  name: 'trainers',
  components: {TrainerAddForm, TrainerUpdateForm},
  mixins: [ListMixin],
  data () {
    return {
      showAdd: false,
      loading: true,
      trainers: [],
      headers: [
        {
          value: 'last_name',
          text: 'imię i nazwisko',
          sortable: true
        },
        {
          value: 'email',
          text: 'e-mail',
          sortable: true
        },
        {
          value: 'is_active',
          text: 'aktywny',
          sortable: true
        },
        {
          value: 'actions',
          text: 'akcje',
          align: 'center',
          sortable: false,
          width: '180px'
        }
      ]
    }
  },
  watch: {
    context: {
      handler () {
        this.getTrainers()
      },
      deep: true
    }
  },
  methods: {
    formatterBool (data) {
      return boolFormatter(data)
    },
    getTrainers () {
      this.loading = true
      let params = this.prepareParams()
      if (this.context.isActive !== null) {
        params['is_active'] = this.context.isActive
      }
      let promise = fetchTrainers(params)
      return promise.then(this.enhanceListData).then((data) => {
        this.loading = false
        this.trainers = data
        return data
      })
    },
    sendMailTrainer (item) {
      let promise = sendMailTrainer(item)
      return promise.then(() => {
        this.refresh()
        iziToast.show({
          message: 'Mail aktywacyjny został wysłany.',
          color: 'green'
        })
      })
    },
    activateTrainer (item) {
      let promise = activateTrainer(item)
      return promise.then(() => {
        this.refresh()
        iziToast.show({
          message: 'Konto zostało aktywowane',
          color: 'green'
        })
      })
    },
    deactivateTrainer (item) {
      let promise = deactivateTrainer(item)
      return promise.then(() => {
        this.refresh()
        iziToast.show({
          message: 'Konto zostało deaktywowane',
          color: 'green'
        })
      }).catch(() => {
        iziToast.show({
          message: 'Nie udało się deaktywować trenera. Istnieją przypisani do niego zawodnicy.',
          color: 'red'
        })
      })
    },
    refresh: _.debounce(function () {
      this.getTrainers()
    }, 400)
  }
}
</script>



// WEBPACK FOOTER //
// src/trainers/AdminTrainers.vue